import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { RegularSection, ColorTitle } from '@/components/Layouts'

interface Card {
    title?: string
    subtitle?: string
}

interface Content {
    title?: string
    cards?: Card[]
}

interface S1_Hero_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S1_Hero_2Props) => {
    const { title, cards = [] } = props.content || {}
    const { blockName: _blockName } = props
    return (
        <RegularSection aria-label='S1_Hero_2' >
            <ColorTitle title={title} colorFrom={0} />
            <Grid
                container
                spacing={2}
            >
                {cards.map((card, index) => (
                    <Grid
                        key={index}
                        size={{ xs: 12, md: 6, lg: 4 }}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'start',
                            alignItems: 'start',
                            border: '2px solid var(--primary-color)',
                            borderRadius: 4,
                            p: 2,
                            minHeight: { xs: 130, },
                        }}
                    >
                        <Typography
                            variant='h3'
                            sx={{ color: 'primary.main' }}
                        >
                            {'0' + (index + 1)}
                        </Typography>
                        <Typography variant='h3'>{card.title}</Typography>
                        <Typography variant='body2'>{card.subtitle}</Typography>
                    </Grid>
                ))}
            </Grid>
        </RegularSection>
    )
}

export default Index
